// Dashboard Events summary page translations (pt-BR), loaded into dashboard.events.summary by ../pt-BR.events.js
module.exports = {
  menu: "Resumo",
  title: "Resumo de Eventos",
  description: "Os indicadores do antigo separador “Eventos”, agora com comparação e tendência.",
  kpis: {
    total: "Total",
    promoted: "Divulgados",
    clicks: "Cliques",
    active: "Ativos",
    shared: "Partilhados",
    newEvents: "Novos",
    linkClicks: "Cliques em links de eventos",
    perDay: "Média de criação por dia",
    topCategory: "Categoria líder",
    topContinent: "Continente líder",
  },
  info: {
    total: "Eventos criados desde o início até ao fim do período, incluindo os apagados.\nFonte: Firebase (contadores de eventos).",
    promoted: "Eventos divulgados no período.\nFonte: Firebase (contadores de eventos).",
    clicks: "Cliques nos links de eventos no período.\nFonte: Firebase (contadores de eventos).",
    active: "Eventos ativos a decorrer no último dia do período.\nFonte: Firebase (eventos).",
    shared: "Eventos partilhados no período.\nFonte: Firebase (contadores de eventos).",
    newEvents: "Eventos criados no período.\nFonte: Firebase (contadores de eventos).",
    linkClicks: "Cliques nos links de eventos no período (o mesmo número de Cliques, sem a divisão por idade).\nFonte: Firebase (contadores de eventos).",
    perDay: "Média de eventos criados por dia no período.\nFonte: Firebase (contadores de eventos).",
    topCategory: "Categoria com mais eventos ativos no último dia do período.\nFonte: Firebase (eventos).",
    topContinent: "Continente com mais eventos ativos no último dia do período.\nFonte: Firebase (eventos).",
  },
  hints: {
    oneDay: "período de apenas 1 dia",
    ofActive: "{pct} dos ativos",
  },
  modals: {
    total: {title: "Total de eventos"},
    promoted: {title: "Eventos divulgados", subtitle: "por faixa etária"},
    clicks: {title: "Cliques em eventos", subtitle: "por faixa etária"},
    active: {title: "Eventos ativos", subtitle: "média diária de eventos ativos"},
    shared: {title: "Eventos partilhados", subtitle: "por faixa etária"},
    newEvents: {title: "Eventos criados"},
  },
  totalSeries: "Total",
  continents: {
    europe: "Europa",
    southAmerica: "América do Sul",
    northAmerica: "América do Norte",
    africa: "África",
    asia: "Ásia",
    oceania: "Oceania",
  },
  panels: {
    map: "Eventos pelo mundo",
    mapNote: "Eventos ativos que decorreram em algum dia do período",
  },
  panelInfo: {
    map: "Eventos ativos que decorreram em algum dia do período, por local.\nFonte: Firebase (eventos).",
  },
};
